export default __webpack_public_path__ + "static/mapExample2-617974402a943d8174467f9304cd59a6.png";